// @flow
import * as React from 'react';
import { Avatar, Stack, Typography } from '@mui/material';
import { darkenHexColor, letterToColorfulHex, lightenHexColor } from '../lib';

type Props = {
  name: string,
  email: string,
  showEmail?: boolean,
  size: number,
  fontSize: number,
  lettersNumber?: number
};
export const UserAvatar = ({name, email, size, fontSize, lettersNumber = 2, showEmail}: Props) => {
  return (
    <Stack gap={1} direction={'row'} alignItems={'center'}>
      <Avatar sx={{ bgcolor: lightenHexColor(letterToColorfulHex(email), 50),
        color: darkenHexColor(letterToColorfulHex(email), 70),
        border: `1px solid ${darkenHexColor(letterToColorfulHex(email), 10)}`,
        width: size, height: size, fontSize }}>
        <b>{name.split(' ').filter(Boolean).map(n => n[0].toUpperCase()).slice(0, lettersNumber).join('')}</b>
      </Avatar>
      <Stack>
        <Typography variant={'body2'} align={'left'} fontWeight={500}>{name}</Typography>
        {showEmail && <Typography variant={'caption'} align={'left'} color={'text.secondary'}>{email}</Typography>}
      </Stack>
    </Stack>
  );
};
